module.exports = __webpack_public_path__ + "static/media/1014835.0e6c9563.jpg";